WiseMetering.Collection.AnalyzeViews = WiseMetering.Collection.extend({
    model: WiseMetering.Model.AnalyzeView,
    url: '/analyze_views'
});
